import React from "react";
import { Link, Button, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Login, Logout } from "@mui/icons-material";
import { userInfo } from "../../auth/AuthProvider";
import { useSetRecoilState, useResetRecoilState, useRecoilValue } from 'recoil';
import { utils, isDebug } from "../../utils"; // utils.js에서 decodeJWT 함수 가져오기
import { useTranslation } from "react-i18next";


export default function AuthButton(props) {
  const { onClick } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const access = sessionStorage.getItem("access");
  const refresh = sessionStorage.getItem("refresh");

  //recoil 사용 선언부
  const setUserInfo = useSetRecoilState(userInfo);
  const resetUserInfo = useResetRecoilState(userInfo);
  const auth = useRecoilValue(userInfo);
  // if (isDebug()) console.log("## AuthButton auth", auth);

  const handleLogin = () => {
    if(onClick !== undefined && onClick !== null)
    {
      onClick(false);   /// 모바일 메뉴 숨기기
    }
    navigate("/login");
  };

  React.useEffect(() => {   
    try {
      if(access === null || refresh === null) {
        return;
      } 
      const decodedPayload = utils.api.decodeJWT(access);
      if(decodedPayload !== null) {
        if (isDebug()) console.log("Decoded JWT Payload:", decodedPayload);
        if (isDebug()) console.log("## JWT memberId:", decodedPayload.memberId);
        if (isDebug()) console.log("## JWT memberName:", decodedPayload.memberName);
        if (isDebug()) console.log("## JWT memberType:", decodedPayload.memberType);
        setUserInfo({
          userId: decodedPayload.memberId,
          userName: decodedPayload.memberName,
          userType: decodedPayload.memberType,
        });
      }
    } catch (error) {
      console.error("Error decoding JWT:", error);  
    }
  }, [access, refresh]);

  const handleLogout = () => {
    if(onClick !== undefined && onClick !== null)
    {
      onClick(false);   /// 모바일 메뉴 숨기기
    }
    sessionStorage.clear();
    resetUserInfo();
    navigate("/", { replace: true });
  };

  const buttonStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    mr: 1.5,
  };

  const textStyles = {
    fontSize: "0.8rem",
    width: "max-content",
    marginRight: "-3px",
    color: "#202124"
  };

  if (access && refresh) {
    return (
      <Tooltip title={`[${auth.userName}] ${t('header.logout')}`} placement="bottom" arrow>
        <Link color="text.primary" sx={{ my: 1, mx: 1.5, }} underline="none" >
          <Button onClick={handleLogout} component="label" variant="text" endIcon={<Logout />}>
            <Typography variant="span" sx={textStyles}>
              {t('header.logout')}
            </Typography>
          </Button>
        </Link>
      </Tooltip>
    );
  } else {
    return (
      <Link color="text.primary" sx={{ my: 1, mx: 1.5, }} underline="none" >
        <Button onClick={handleLogin} component="label" variant="text" endIcon={<Login />}>
          <Typography variant="span" sx={textStyles}>
            {t('header.login')}
          </Typography>
        </Button>
      </Link>
    );
  }
}
